<template>
    <view-container :headline="'기술자 상세'">
        <view-card :headline="'기술자정보'" :disabled="true">
            <v-row>
                <view-card-column>
                    <v-text-field
                        v-for="(
                            { label, vModel, _class }, index
                        ) in userInfo.basic"
                        :key="index"
                        :label="label"
                        placeholder=" "
                        hide-details
                        :class="_class"
                        :value="vModel"
                    ></v-text-field>
                </view-card-column>
                <view-card-column>
                    <v-col
                        cols="12"
                        sm="12"
                        class="py-0"
                        @click="showOverlay(userInfo.photo.src)"
                        style="pointer-events: auto; cursor: pointer"
                    >
                        <span>{{ userInfo.photo.label }}</span>
                        <v-img
                            contain
                            max-width="100%"
                            max-height="140"
                            v-if="userInfo.photo.src"
                            :src="userInfo.photo.src"
                        />
                    </v-col>
                </view-card-column>
            </v-row>
        </view-card>
        <view-card :headline="'기술자상태'" :disabled="!isConsole">
            <view-card-row :mt="false" :heading="'기술자 승인'">
                <v-col cols="12" class="py-0 caption">
                    <v-switch
                        v-model="user.scope"
                        value="technician"
                        color="green"
                        hide-details
                        class="mt-0"
                        @change="isConsole && saveScope()"
                    ></v-switch>
                </v-col>
            </view-card-row>
        </view-card>
        <view-card :headline="'기술자정보상세'" :disabled="true">
            <view-card-row :mt="false" :heading="'시공분야'">
                <v-col cols="12" class="py-0 caption">
                    <v-radio-group
                        v-model="userInfo.interiorType.data"
                        row
                        hide-details
                        class="mt-0"
                    >
                        <v-radio
                            v-for="(field, index) in field_item"
                            :key="index"
                            :label="field"
                            :value="field"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </view-card-row>
            <view-card-row
                :heading="userInfo.interiorCategories.label"
                v-if="userInfo.interiorCategories.data"
                :sm="12"
            >
                <view-chips
                    :items="userInfo.interiorCategories.data"
                ></view-chips>
            </view-card-row>
            <view-card-row
                :heading="userInfo.interiorAreas.label"
                v-if="userInfo.interiorAreas.data"
                :sm="12"
            >
                <view-chips :items="userInfo.interiorAreas.data"></view-chips>
            </view-card-row>
            <v-row class="mt-4">
                <v-col cols="12" sm="6" class="py-0">
                    <v-text-field
                        :label="userInfo.career.label"
                        placeholder=" "
                        hide-details
                        v-model="userInfo.career.data"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-4">
                <v-col cols="12" class="py-0">
                    <v-text-field
                        :label="userInfo.summary.label"
                        placeholder=" "
                        hide-details
                        v-model="userInfo.summary.data"
                    ></v-text-field>
                </v-col>
            </v-row>
            <view-card-row :heading="userInfo.introduction.label" :sm="12">
                <v-col cols="12" class="py-0 caption">
                    <naver-smarteditor
                        v-model="userInfo.introduction.data"
                    ></naver-smarteditor>
                </v-col>
            </view-card-row>
        </view-card>
        <v-row> <v-col> </v-col></v-row>
        <view-overlay
            :overlay="overlay"
            @hide-overlay="hideOverlay"
        ></view-overlay>
    </view-container>
</template>
<script>
import api from "@/api";
import ViewContainer from "@/components/console/dumb/view-container.vue";
import ViewCard from "@/components/console/dumb/view-card.vue";
import ViewCardColumn from "@/components/console/dumb/view-card-column.vue";
import ViewOverlay from "@/components/console/dumb/view-overlay.vue";
import ViewCardRow from "@/components/console/dumb/view-card-row.vue";
import ViewChips from "@/components/console/dumb/view-chips.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
export default {
    components: {
        ViewContainer,
        ViewCard,
        ViewCardColumn,
        ViewOverlay,
        ViewCardRow,
        ViewChips,
        NaverSmarteditor,
    },
    data() {
        return {
            user: {},
            field_item: ["종합인테리어", "부분인테리어"],
            overlay: {
                show: false,
                src: undefined,
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let _id = this.$route.params._user;
            try {
                const { user } = await api.console.users.getUser({ _id });
                this.user = user;
            } catch (error) {
                console.error(error);
            }
        },

        showOverlay(src) {
            this.overlay = { show: true, src };
        },

        hideOverlay() {
            this.overlay = { show: false, src: undefined };
        },

        async saveScope() {
            try {
                const { _id, scope } = this.user;
                await api.console.users.putUser({ _id, scope });
            } catch (error) {
                console.error(error);
                alert(
                    error.response ? error.response.data.message : error.message
                );
            }
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isConsole() {
            return this.scope.includes("console");
        },
        userInfo() {
            const _class = "mt-4";
            return {
                basic: [
                    {
                        label: "기술자이름",
                        vModel: this.user?.name || null,
                        _class: "mt-0",
                    },
                    {
                        label: "연락처",
                        vModel: this.user?.phone || null,
                        _class,
                    },
                    {
                        label: "이메일",
                        vModel: this.user?.email || null,
                        _class,
                    },
                ],
                photo: {
                    label: "프로필사진",
                    src: this.user?.meta?.photo || null,
                },
                interiorType: {
                    label: "시공분야",
                    data: this.user?.meta?.interiorType || null,
                },
                interiorCategories: {
                    label: "부분인테리어 카테고리",
                    data: this.user?.meta?.interiorCategories || null,
                },
                interiorAreas: {
                    label: "시공지역",
                    data: this.user?.meta?.interiorAreas || null,
                },
                career: {
                    label: "시공경력",
                    data: [
                        this.user?.meta?.interiorCareerYear || null,
                        this.user?.meta?.interiorCareerMonth || null,
                    ].reduce(
                        (s, t, i) => (t ? s + (i ? ` ${t}개월` : `${t}년`) : s),
                        ""
                    ),
                },
                summary: {
                    label: "기본소개",
                    data: this.user?.meta?.summary || null,
                },
                introduction: {
                    label: "자기소개",
                    data: this.user?.meta?.introduction || null,
                },
            };
        },
    },
};
</script>